// Config panel for the "activate_controller" action block
import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  FormHelperText
} from '@mui/material';
import { qbusApi } from '../../../services/apiClient';

const ActivateControllerConfig = ({ config, locationId, onChange, onSummaryChange }) => {
  const [controllers, setControllers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!locationId) return;
    setLoading(true);
    qbusApi.getControllersForLocation(locationId)
      .then((res) => setControllers(res.data.controllers || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [locationId]);

  const handleChange = (value) => {
    const updated = { ...config, controllerId: value };
    onChange(updated);
    const ctrl = controllers.find((c) => c.id === value);
    const name = ctrl?.friendlyName || ctrl?.name || `#${value}`;
    onSummaryChange(`Activate ${name}`);
  };

  if (loading) return <CircularProgress size={24} />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Sends an activate command to a Qbus controller via MQTT.
      </Typography>

      <FormControl fullWidth size="small" required>
        <InputLabel>Controller</InputLabel>
        <Select
          value={config.controllerId || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Controller"
        >
          {controllers.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.friendlyName || c.name} ({c.serialNumber || c.id})
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>The controller to activate</FormHelperText>
      </FormControl>
    </Box>
  );
};

export default ActivateControllerConfig;
